@if (dialogData.ticket(); as ticket) {
  <rt-dialog-header [heading]="ticket.name"></rt-dialog-header>
  <rt-dialog-body class="no-padding" layout-justify-center>
    <div class="column ticket-col">
      <ticket-info-card
        [ticket]="ticket"
        (priorityChanged)="updateTicket({ priority: $event })"
        (assigneesChanged)="updateTicketAssignees($event)"
        (statusChanged)="moveTicket({ status: $event })"
        (cancelClick)="cancelTicket()"
      />
      <div class="rt-card form-present">
        <rt-heading margin-bottom-small-x>
          {{ 'tlc.ask_hr.request_dialog.form' | translate }}
        </rt-heading>
        <rt-divider margin-bottom-small-x />
        <dynamic-form-present [formItems]="presentFormItems()" />
      </div>
    </div>
    <div class="column notes-col">
      <div class="rt-card notes-card">
        <rt-heading margin-bottom-small-x>
          {{ 'tlc.ask_hr.request_dialog.comments' | translate }}
        </rt-heading>
        <rt-note-form
          [active]="noteActive()"
          [note]="$any({ id: NEW_NOTE_ID })"
          [placeholder]="'tlc.ask_hr.request_dialog.add_comment' | translate"
          [localStorageKeyBuilder]="localStorageKeyBuilder"
          [noteSaveLoading]="notesBeingSaved().includes(NEW_NOTE_ID)"
          [noteToMention]="noteToMention"
          (noteSaveClick)="noteSaveClick($event)"
          (cancelClick)="noteActive.set(false)"
          (noteEditClick)="noteActive.set(true)"
        />
        <rt-notes-list
          [notes]="notes()"
          [localStorageKeyBuilder]="localStorageKeyBuilder"
          [noteToMention]="noteToMention"
          [isOwnerFn]="isOwnerFn"
          [getOwnerFn]="getOwnerFn"
          [isAutomatedActionNoteFn]="isAutomatedActionNoteFn"
          [notesBeingEdited]="editedNotes()"
          [notesBeingSaved]="notesBeingSaved()"
          [notesBeingRepliedTo]="replyNotes()"
          [canReply]="false"
          [canPin]="false"
          (noteEditClick)="noteEditClick($event)"
          (noteSaveClick)="noteSaveClick($event)"
          (noteDiscardClick)="cancelClick($event)"
          (noteReplyClick)="noteReplyClick($event)"
          (noteDeleteClick)="noteDeleteClick($event)"
          [class.main-form-active]="noteActive()"
        />
      </div>
    </div>
  </rt-dialog-body>
}
